import styled from 'styled-components';

export const ServiceStyle = styled.div`
  .service-content {
    margin-top: 16px;
  }

  .service-cta-chat {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: flex-end;
    pointer-events: none;
    &__wrapper {
      max-width: 376px;
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 16px;
    }
    &__button {
      pointer-events: initial;
      .MuiButtonBase-root {
        background: ${(props) => props.theme.primary.primary50};
      }
    }
  }
  .content-steps {
    margin-bottom: 24px;
    .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
      padding: 0 2px;
    }
    .MuiStepIcon-root.MuiStepIcon-completed {
      color: ${(props) => props.theme.primary.primary60};
    }
    .MuiStepIcon-root.MuiStepIcon-active {
      color: ${(props) => props.theme.primary.primary60};
    }
  }
  .MuiTab-textColorPrimary.Mui-selected {
    color: ${(props) => props.theme.primary.primary50};
  }

  .PrivateTabIndicator-colorPrimary-2 {
    background-color: ${(props) => props.theme.primary.primary50};
  }

  /* Tabs style */
  .MuiTab-root {
    min-width: unset;
    .MuiTouchRipple-root {
      display: none;
    }
  }
  .MuiPaper-root,
  .MuiStep-root {
    padding: 0;
  }
  .MuiTypography-root {
    font-size: 12px;
    line-height: 16px;
  }
`;
